export const NEW_CARD_POSITION = "NEW_SWITCH_POSITION";
export const NEW_SECTION_MESSAGE = "NEW_SECTION_MESSAGE";
